import type {
  AssetResourceListResponseV2Api,
  EnumAssetTypeV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { AssetType, OsAssetsByIdResponse } from '../../../models/osAssets.model';

export function transformIncomingOsAssetTypeToInternalType(type?: EnumAssetTypeV2Api): AssetType | undefined {
  return type satisfies AssetType | undefined;
}

export function mapOsAssetsById({ pagination, data }: AssetResourceListResponseV2Api): OsAssetsByIdResponse {
  return {
    pagination: {
      itemsPerPage: pagination.itemsPerPage,
      startIndex: pagination.startIndex,
      totalResults: pagination.totalResults,
    },
    data: data.map(({ id, type }) => ({
      id,
      type: transformIncomingOsAssetTypeToInternalType(type),
    })),
  };
}
